import React from "react";

/**
 * Renders a JSON-LD <script> tag for any schema.org object. Use this
 * for structured data — Google rich results, AI Overviews, Bing
 * featured cards.
 *
 * App Router note: metadata exports CANNOT contain JSON-LD (no
 * arbitrary <script> hook). Render this directly inside the page
 * body — Google parses it from anywhere in the document.
 *
 * Usage:
 *   <JsonLd data={{ "@context": "https://schema.org", "@type": "Organization", ... }} />
 */
export default function JsonLd({ data }: { data: Record<string, unknown> | Record<string, unknown>[] }) {
  return (
    <script
      type="application/ld+json"
      // JSON.stringify handles escaping. Don't template-string this —
      // a stray quote in any property value would break the page.
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
